<template src="./zero-server-course.html"></template>

<script>
  import appHeader from "../../../shared-module/components/app-header/app-header.vue";
  import axios from "axios";
  import { mainBackend } from "../../../../environment/environment";
  import storageService from "../../services/storage-service";
  import io from "socket.io-client";
  import ClickOutside from "vue-click-outside";

  const BASE_URL = `${process.env.VUE_APP_SOCKET_URL}/lmsservice/v1`;
  //const BASE_URL = "http://localhost:3007/lmsservice/v1";

  const DEFAULT_EXPIRY_HTML = `
<div style="text-align: center; padding: 50px; font-family: sans-serif;">
  <h1 style="color: #e74c3c;">Course Ended</h1>
  <p style="font-size: 18px; color: #2c3e50;">This course is not free now.</p>
  <p style="color: #7f8c8d;">You can contact our team to get access to this course.</p>
  <a href="https://www.nearpeer.org/contact" style="display: inline-block; margin-top: 20px; padding: 10px 20px; background-color: #3498db; color: white; text-decoration: none; border-radius: 5px;">Contact Support</a>
</div>`;

  export default {
    name: "zero-server-course",
    components: {
      "app-header": appHeader,
    },
    directives: {
      ClickOutside,
    },
    data() {
      return {
        // Form data
        sourceCourseId: "",
        fromDate: "",
        toDate: "",
        redirectLink: "",
        expiryHtml: DEFAULT_EXPIRY_HTML, // Pre-populate with default
        
        // Course Dropdown Data
        instructor_id: -1,
        inputValueCourse: "",
        // ... (rest of data properties remain unchanged)
        
        // ... (rest of data)
        itemListCourses: [],
        loadingCourse: false,
        courseNotFound: false,
        apiLoadedCourse: false,
        isCourseFocused: false,
        selectedCourse: { name: "Click here to Select Course" },
        
        // Clone configs list
        configs: [],
        totalConfigs: 0,
        currentPage: 1,
        totalPages: 1,
        
        // Socket and progress
        socket: null,
        isCloning: false,
        currentConfigId: null,
        socketRoom: "",
        
        // Progress tracking
        progressSteps: [],
        currentStep: "",
        currentProgress: 0,
        totalProgress: 0,
        progressMessage: "",
        
        // Video upload progress
        videoUploadProgress: {},
        
        // Logs
        logs: [],
        
        // UI state
        isLoading: false,
        showForm: false,
        showHtmlModal: false,
        error: null,
        success: null,
        isCancelling: false,
        
        // Clone status state (idle, in_progress, completed, failed, cancelled)
        cloneStatus: 'idle',
        lastResult: null, // Stores details of last completed/failed/cancelled operation
      };
    },
    // ... computed and created ...
    computed: {
      progressPercent() {
        if (this.totalProgress === 0) return 0;
        return Math.round((this.currentProgress / this.totalProgress) * 100);
      },
      canStartClone() {
        return this.sourceCourseId && !this.isCloning;
      },
      statusIcon() {
        switch (this.cloneStatus) {
          case 'in_progress': return 'fas fa-spinner fa-spin';
          case 'completed': return 'fas fa-check-circle';
          case 'failed': return 'fas fa-times-circle';
          case 'cancelled': return 'fas fa-ban';
          default: return 'fas fa-clone';
        }
      },
      statusText() {
        switch (this.cloneStatus) {
          case 'in_progress': return 'Cloning in Progress';
          case 'completed': return 'Cloning Completed Successfully!';
          case 'failed': return 'Cloning Failed';
          case 'cancelled': return 'Cloning Cancelled';
          default: return 'Ready to Clone';
        }
      }
    },
    created() {
      this.instructor_id = storageService.get("uid");
      this.getCoursesByInstructorId();
      this.fetchConfigs();
    },
    beforeDestroy() {
      this.disconnectSocket();
    },
    methods: {
      // ... existing methods ...
      async getCoursesByInstructorId() {
        try {
          this.courseNotFound = false;
          this.loadingCourse = true;
          // Use main backend URL directly with axios to match quiz-service implementation
          // but avoiding the full service wrapper import if we just need this one call
          const response = await mainBackend.get("instructors/instructorUniversityList", {
            params: { instructor_id: this.instructor_id },
            headers: {
              uid: storageService.get("uid"),
              Authorization: storageService.get("authorization"),
            }
          });
          
          if (response) {
            this.loadingCourse = false;
            let courses = [];
            if (response.data.data) {
              response.data.data.forEach((course) => {
                course.courses.forEach((crs) => {
                  crs.value = crs.id;
                  courses.push(crs);
                });
              });
            }
            this.itemListCourses = courses;
            this.apiLoadedCourse = true;
          }
        } catch (error) {
          this.loadingCourse = false;
          this.courseNotFound = true;
          console.error("Error fetching courses:", error);
          this.showError(error.message || "Failed to load courses");
        }
      },

      hideCourse() {
        this.isCourseFocused = false;
      },

      onCourseClick() {
        this.isCourseFocused = !this.isCourseFocused;
        if (this.isCourseFocused) {
          this.$nextTick(() => {
            // this.$refs.dropdowninput.focus();
          });
        }
      },

      selectCourse(item) {
        this.selectedCourse = item;
        this.sourceCourseId = item.id;
        // Update input value to include cloned indicator
        let courseName = item.name;
        if (item.isCloned) {
          courseName += ' (cloned)';
        }
        this.inputValueCourse = courseName;
        this.hideCourse();
      },

      clearCourse() {
        this.selectedCourse = { name: "Click here to Select Course" };
        this.sourceCourseId = "";
        this.inputValueCourse = "";
      },

      retry() {
        this.getCoursesByInstructorId();
      },

      itemVisible(item, currentInput) {
        let currentName = item.name.toLowerCase();
        let currentInputLower = currentInput.toLowerCase();
        return currentName.includes(currentInputLower);
      },

      async fetchConfigs(page = 1) {
        try {
          this.isLoading = true;
          this.currentPage = page;
          
          const response = await axios.get(`${BASE_URL}/zero-server-course/configs`, {
            params: { page, limit: 10 }
          });
          
          if (response && response.data && response.data.success) {
            this.configs = response.data.configs || [];
            this.totalConfigs = response.data.total || 0;
            this.totalPages = response.data.totalPages || 1;
          }
        } catch (error) {
          console.error("Error fetching configs:", error);
          this.showError("Failed to load cloning history");
        } finally {
          this.isLoading = false;
        }
      },
      
      async startClone() {
        if (!this.sourceCourseId) {
          this.showError("Please enter a source course ID");
          return;
        }

        if (!this.redirectLink) {
          this.showError("Please enter a redirect link");
          return;
        }

        if (!this.fromDate) {
          this.showError("Please select a From Date");
          return;
        }

        if (!this.toDate) {
          this.showError("Please select a To Date");
          return;
        }
        
        try {
          this.isCloning = true;
          this.showForm = false; // Close the modal immediately
          this.cloneStatus = 'in_progress';
          this.lastResult = null;
          this.error = null;
          this.success = null;
          this.logs = [];
          this.progressSteps = [];
          this.videoUploadProgress = {};
          
          this.addLog("🚀 Starting course clone process...");
          
          // Use the current expiryHtml (which is either default or user-edited)
          const payload = {
            source_course_id: parseInt(this.sourceCourseId),
            from_date: this.fromDate,
            to_date: this.toDate,
            redirect_link: this.redirectLink,
            expiry_html: this.expiryHtml,
            user_id: storageService.get("uid")
          };
          
          const response = await axios.post(`${BASE_URL}/zero-server-course/clone`, payload);
          
          if (response && response.data && response.data.success) {
            this.currentConfigId = response.data.config_id;
            this.socketRoom = response.data.socket_room;
            
            this.addLog(`Clone initiated. Config ID: ${this.currentConfigId}`);
            this.addLog("Connecting to real-time progress updates...");
            
            // Connect to socket for real-time updates
            this.connectSocket();
          } else {
            throw new Error(response.data.message || "Failed to start clone");
          }
        } catch (error) {
          console.error("Error starting clone:", error);
          this.showError(error.response?.data?.message || error.message || "Failed to start cloning");
          this.isCloning = false;
        }
      },
      
      connectSocket() {
        // const baseUrl = process.env.VUE_APP_SOCKET_URL;
        const baseUrl = "http://localhost:3007";
        
        this.socket = io(`${baseUrl}/zero-server-course`, {
          path: "/lmsservice/socket/zero-server-course",
          transports: ["websocket", "polling"],
        });
        
        this.socket.on("connect", () => {
          this.addLog("Connected to progress socket");
          this.socket.emit("join-clone-room", { configId: this.currentConfigId });
        });
        
        this.socket.on("room-joined", (data) => {
          this.addLog(data.message);
        });
        
        this.socket.on("clone_started", (data) => {
          this.addLog(`Clone started for course ID: ${data.sourceCourseId}`);
          this.progressSteps.push({
            step: "started",
            message: data.message,
            time: new Date().toLocaleTimeString()
          });
        });
        
        this.socket.on("progress_update", (data) => {
          this.currentStep = data.step;
          this.currentProgress = data.percent; // Use granular percent
          this.totalProgress = 100; // Total is always 100% now
          this.progressMessage = data.message;
          
          this.addLog(`[${data.step}] ${data.percent}% - ${data.message}`);
          
          this.progressSteps.push({
            step: data.step,
            current: data.current,
            total: data.total,
            message: data.message,
            time: new Date().toLocaleTimeString()
          });
        });
        
        this.socket.on("video_upload_progress", (data) => {
          this.$set(this.videoUploadProgress, data.videoId, {
            name: data.videoName,
            percent: data.percent, // This is already granular or relative
            message: data.message
          });
          
          if (data.percent === 100) {
            this.addLog(`Video "${data.videoName}" uploaded successfully`);
          }
        });
        
        this.socket.on("clone_completed", (data) => {
          this.addLog(`✅ Clone completed! New course ID: ${data.newCourseId}`);
          this.showSuccess(`Course cloned successfully! New course: "${data.newCourseName}" (ID: ${data.newCourseId})`);
          this.isCloning = false;
          this.cloneStatus = 'completed';
          this.lastResult = {
            type: 'success',
            newCourseId: data.newCourseId,
            newCourseName: data.newCourseName,
            message: data.message,
            timestamp: new Date().toLocaleString()
          };
          this.resetForm();
          this.fetchConfigs();
          this.disconnectSocket();
        });
        
        this.socket.on("clone_error", (data) => {
          this.addLog(`❌ Error: ${data.error}`);
          this.showError(data.message || data.error);
          this.isCloning = false;
          this.cloneStatus = 'failed';
          this.lastResult = {
            type: 'error',
            error: data.error,
            message: data.message,
            timestamp: new Date().toLocaleString()
          };
          this.disconnectSocket();
          this.fetchConfigs();
        });
        
        this.socket.on("disconnect", () => {
          this.addLog("Disconnected from progress socket");
        });
        
        this.socket.on("error", (error) => {
          console.error("Socket error:", error);
          this.addLog(`Socket error: ${error.message || error}`);
        });

        // Cancel event handlers
        this.socket.on("cancel-acknowledged", (data) => {
          this.addLog(data.message);
        });

        this.socket.on("cancel-failed", (data) => {
          this.showError(`Cancel failed: ${data.error}`);
          this.isCancelling = false;
        });

        this.socket.on("clone_cancelled", (data) => {
          this.addLog(`⚠️ Cloning cancelled: ${data.message}`);
          this.showSuccess("Cloning was cancelled successfully. Partial progress has been rolled back.");
          this.isCloning = false;
          this.isCancelling = false;
          this.cloneStatus = 'cancelled';
          this.lastResult = {
            type: 'cancelled',
            message: data.message,
            timestamp: new Date().toLocaleString()
          };
          this.resetForm();
          this.fetchConfigs();
          this.disconnectSocket();
        });
      },
      
      disconnectSocket() {
        if (this.socket) {
          if (this.currentConfigId) {
            this.socket.emit("leave-clone-room", { configId: this.currentConfigId });
          }
          this.socket.disconnect();
          this.socket = null;
        }
      },
      
      async deleteConfig(configId) {
        if (!confirm("Are you sure you want to delete this clone configuration?")) {
          return;
        }
        
        try {
          await axios.delete(`${BASE_URL}/zero-server-course/config/${configId}`);
          
          this.showSuccess("Configuration deleted successfully");
          this.fetchConfigs();
        } catch (error) {
          console.error("Error deleting config:", error);
          this.showError("Failed to delete configuration");
        }
      },

      cancelClone() {
        if (!this.socket || !this.currentConfigId) {
          this.showError("Cannot cancel: not connected to cloning process");
          return;
        }

        if (this.isCancelling) return;

        if (!confirm("Are you sure you want to cancel the cloning operation? Any partial progress will be rolled back.")) {
          return;
        }

        this.isCancelling = true;
        this.addLog("Requesting cancellation...");
        this.socket.emit("cancel-clone", { configId: this.currentConfigId });
      },
      
      openHtmlModal() {
        this.showHtmlModal = true;
      },
      
      closeHtmlModal() {
        this.showHtmlModal = false;
      },

      copyCourseUrl(indexUrl) {
        const fullUrl = `https://nearpeer.org/${indexUrl}`;
        navigator.clipboard.writeText(fullUrl).then(() => {
          this.showSuccess(`Course URL copied: ${fullUrl}`);
        }).catch(err => {
          console.error('Failed to copy URL:', err);
          this.showError('Failed to copy URL');
        });
      },

      async downloadEnrolledCSV(courseId) {
        try {
          this.showInfo('Downloading enrolled students CSV...');
          
          const response = await axios.get(`${BASE_URL}/zero-server-course/enrolled-csv/${courseId}`, {
            responseType: 'blob'
          });
          
          // Create download link
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `enrolled_students_course_${courseId}.csv`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          
          this.showSuccess('CSV downloaded successfully');
        } catch (error) {
          console.error('Error downloading CSV:', error);
          this.showError('Failed to download CSV');
        }
      },

      getStatusClass(status) {
        switch (status) {
          case "completed": return "status-completed";
          case "in_progress": return "status-in-progress";
          case "failed": return "status-failed";
          case "cancelled": return "status-cancelled";
          default: return "status-pending";
        }
      },
      
      formatDate(dateString) {
        if (!dateString) return "-";
        return new Date(dateString).toLocaleString();
      },
      
      addLog(message) {
        this.logs.unshift({
          time: new Date().toLocaleTimeString(),
          message
        });
        
        // Keep only last 100 logs
        if (this.logs.length > 100) {
          this.logs = this.logs.slice(0, 100);
        }
      },
      
      showError(message) {
        this.error = message;
        this.success = null;
        setTimeout(() => { this.error = null; }, 10000);
      },
      
      showSuccess(message) {
        this.success = message;
        this.error = null;
        setTimeout(() => { this.success = null; }, 10000);
      },

      showInfo(message) {
        // For now, use success toast for info messages
        this.success = message;
        this.error = null;
        setTimeout(() => { this.success = null; }, 5000);
      },
      
      resetForm() {
        this.sourceCourseId = "";
        this.selectedCourse = { name: "Click here to Select Course" };
        this.inputValueCourse = "";
        this.fromDate = "";
        this.toDate = "";
        this.redirectLink = "";
        this.expiryHtml = DEFAULT_EXPIRY_HTML; // Reset to default HTML
      },
      
      toggleForm() {
        // Prevent closing if HTML modal is open (since it triggers click-outside)
        if (this.showHtmlModal) return;
        
        this.showForm = !this.showForm;
        if (!this.showForm) {
          this.resetForm();
        }
      },
      
      changePage(page) {
        if (page < 1 || page > this.totalPages || page === this.currentPage) return;
        this.fetchConfigs(page);
      }
    },
  };
</script>

<style src="./zero-server-course.css" scoped></style>
